export default __webpack_public_path__ + "static/11-3--16071916e266eb4ea0a4670efd71290a.png";